/** Hides API/string placeholders like "null" in pickup assignment UI. */
export function sanitizePickupDisplayText(value: string | number | null | undefined): string {
  if (value === null || value === undefined) return "—";
  const s = String(value).trim();
  if (s === "" || s.toLowerCase() === "null" || s.toLowerCase() === "undefined") {
    return "—";
  }
  return s;
}
